import React, { useState, useEffect } from "react";
import HeatmapTable, { G, O, R } from "./HeatmapTable";
import Loading from "../../../../common-components/Loading";
import { getHeatmapYTDAPI } from "../../../../api/reports-api";

const COLS = [
  { key: "ytdRevActuals", label: "YTD Revenue\nActuals", w: 140, isCurrency: true  },
  { key: "ytdRevBudget",  label: "YTD Revenue\nBudget",  w: 140, isCurrency: true  },
  { key: "ytdGmActuals",  label: "YTD GM\nActuals",      w: 120, isCurrency: true  },
  { key: "ytdGmBudget",   label: "YTD GM\nBudget",       w: 120, isCurrency: true  },
  { key: "vacantFTEs",    label: "Vacant FTEs",          w: 90,  isCurrency: false },
];

function hexToStatus(hex) {
  if (!hex) return null;
  if (hex === "#ff0000") return R;
  if (hex === "#ffff00") return O;
  return G;
}

function mapRow(r) {
  return {
    id:            r.contractId,
    projectName:   r.projectName,
    pm:            r.programManager,
    ytdRevActuals: r.contractRevenue,
    ytdRevBudget:  r.contractRevenueBudget,
    ytdGmActuals:  r.grossMargin,
    ytdGmBudget:   r.grossMarginBudget,
    vacantFTEs:    r.vacantFte,
    financial:     hexToStatus(r.financial),
    performer:     hexToStatus(r.perform),
    funding:       hexToStatus(r.funding),
    staffing:      hexToStatus(r.staffing),
    culture:       hexToStatus(r.culture),
    customer:      hexToStatus(r.customer),
    doge:          hexToStatus(r.doge),
  };
}

function mapTotal(t) {
  return {
    ytdRevActuals: t.contractRevenue,
    ytdRevBudget:  t.contractRevenueBudget,
    ytdGmActuals:  t.grossMargin,
    ytdGmBudget:   t.grossMarginBudget,
    vacantFTEs:    t.vacantFte,
    financial: null, performer: null, funding: null,
    staffing:  null, culture:   null, customer: null, doge: null,
  };
}

export default function YTDHeatmap({ filters, onMeta }) {
  const [loading,  setLoading]  = useState(true);
  const [rows,     setRows]     = useState([]);
  const [totalRow, setTotalRow] = useState(null);
  const [title,    setTitle]    = useState("YTD Heatmap");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getHeatmapYTDAPI(filters)
      .then((res) => {
        if (cancelled) return;
        const d = res?.data;
        if (d) {
          setRows((d.rows || []).map(mapRow));
          setTotalRow(mapTotal(d.totals || {}));
          setTitle(`YTD Heatmap — FY${d.fiscalYear}`);
          onMeta?.({ actualThroughMonth: d.actualThroughMonth, fiscalYear: d.fiscalYear });
        }
      })
      .catch(() => {})
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [JSON.stringify(filters)]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) return <Loading />;
  return <HeatmapTable title={title} cols={COLS} totalRow={totalRow} rows={rows} />;
}
